/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OurMediaOutlet } from './OurMediaOutlet';
import {
    OurMediaOutletFromJSON,
    OurMediaOutletFromJSONTyped,
    OurMediaOutletToJSON,
} from './OurMediaOutlet';

/**
 * 自社メディアリストのメディア一覧を返すレスポンス
 * @export
 * @interface GetOurMediaListMediaOutletsResponse
 */
export interface GetOurMediaListMediaOutletsResponse {
    /**
     * 自社メディアリストに含まれるメディアの総数（fieldsで指定された時だけ）
     * @type {number}
     * @memberof GetOurMediaListMediaOutletsResponse
     */
    totalCount?: number;
    /**
     * ワンクリック登録解除されたメディアの総数
     * @type {number}
     * @memberof GetOurMediaListMediaOutletsResponse
     */
    unsubscriptionTotalCount: number;
    /**
     * 指定範囲のメディア一覧
     * @type {Array<OurMediaOutlet>}
     * @memberof GetOurMediaListMediaOutletsResponse
     */
    ourMediaOutlets: Array<OurMediaOutlet>;
}

/**
 * Check if a given object implements the GetOurMediaListMediaOutletsResponse interface.
 */
export function instanceOfGetOurMediaListMediaOutletsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "unsubscriptionTotalCount" in value;
    isInstance = isInstance && "ourMediaOutlets" in value;

    return isInstance;
}

export function GetOurMediaListMediaOutletsResponseFromJSON(json: any): GetOurMediaListMediaOutletsResponse {
    return GetOurMediaListMediaOutletsResponseFromJSONTyped(json, false);
}

export function GetOurMediaListMediaOutletsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOurMediaListMediaOutletsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'unsubscriptionTotalCount': json['unsubscription_total_count'],
        'ourMediaOutlets': ((json['our_media_outlets'] as Array<any>).map(OurMediaOutletFromJSON)),
    };
}

export function GetOurMediaListMediaOutletsResponseToJSON(value?: GetOurMediaListMediaOutletsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'unsubscription_total_count': value.unsubscriptionTotalCount,
        'our_media_outlets': ((value.ourMediaOutlets as Array<any>).map(OurMediaOutletToJSON)),
    };
}

